// extracted by mini-css-extract-plugin
export var immediateAppointment = "index-module--immediate-appointment--usMN7";